import type { SigningTheme } from '@getaccept/lib-shared/src/signing-theme/types/theme';

export interface ThemeState {
  theme: SigningTheme;
}

export enum ThemeAction {
  Load = 'load',
}

export enum ThemeMutation {
  SetTheme = 'setTheme',
}
